module.exports = __webpack_public_path__ + "img/1_07.cf882648.jpg";